// extracted by mini-css-extract-plugin
export default {"title":"NotEnoughMoney_title__PGhNi","img":"NotEnoughMoney_img__2eQrT","paragraph":"NotEnoughMoney_paragraph__6nPbd","button":"NotEnoughMoney_button__wXRLJ"};